import { defineMessages } from 'react-intl';

export const unitsMessages = defineMessages({
    units: {
        id: 'units',
        defaultMessage: 'Units',
    },
    unit: {
        id: 'unit-single',
        defaultMessage: 'Unit',
    },
    abbreviation: {
        id: 'abbreviation',
        defaultMessage: 'Abbreviation',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    createUnitSuccess: {
        id: 'create-unit-success',
        defaultMessage: 'Unit created',
    },
    createUnitSuccessDescription: {
        id: 'create-unit-success-description',
        defaultMessage: 'Unit {entry} has been successfully created.',
    },
    addUnitSubtitle: {
        id: 'add-unit-subtitle',
        defaultMessage: 'Create a new unit',
    },
    deleteUnit: {
        id: 'delete-unit',
        defaultMessage: 'Delete unit',
    },
    deleteUnitSuccess: {
        id: 'delete-unit-success',
        defaultMessage: 'Unit deleted',
    },
    deleteUnitSuccessDescription: {
        id: 'delete-unit-success-description',
        defaultMessage: 'The unit has been successfully deleted.',
    },
    confirmDeleteUnit: {
        id: 'confirm-delete-unit',
        defaultMessage: 'Are you sure you want to delete this unit? This action cannot be undone.',
    },
    deleteUnitSubtitle: {
        id: 'delete-unit-subtitle',
        defaultMessage: 'Permanently delete unit {entity}',
    },
    editUnitSubtitle: {
        id: 'edit-unit-subtitle',
        defaultMessage: 'Edit unit {entity}',
    },
    updateUnitSuccess: {
        id: 'update-unit-success',
        defaultMessage: 'Unit updated',
    },
    updateUnitSuccessDescription: {
        id: 'update-unit-success-description',
        defaultMessage: 'Unit {entity} has been successfully updated.',
    },
});
